import FilterForm from 'components/forms/FilterForm';
import { DatePicker, Form, FormProps, Input } from 'antd';
import { InputMask } from 'components/form-items/InputMask';

export interface ICompaniesFilter {
  by_name: string;
  by_cnpj: string;
  created_after: string;
  created_before: string;
}

interface CompaniesFilterProps {
  searchFormProps: FormProps<ICompaniesFilter>;
}

export const CompaniesFilter = ({ searchFormProps }: CompaniesFilterProps) => {
  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Form.Item name="by_name">
        <Input placeholder="Nome da unidade" className="lg:min-w-[300px]" />
      </Form.Item>

      <Form.Item name="by_cnpj">
        <InputMask mask="00.000.000/0000-00" placeholder="CNPJ" />
      </Form.Item>

      <Form.Item name="created_after">
        <DatePicker
          placeholder="Cadastro (a partir de)"
          style={{ width: '100%' }}
          format={'DD/MM/YYYY'}
        />
      </Form.Item>

      <Form.Item name="created_before">
        <DatePicker
          placeholder="Cadastro (término em)"
          style={{ width: '100%' }}
          format={'DD/MM/YYYY'}
        />
      </Form.Item>
    </FilterForm>
  );
};
